// extracted by mini-css-extract-plugin
export default {"copyQuotaModalFormItem":"styles_copy-quota-modal-form-item__5NyG1"};